import { render, staticRenderFns } from "./MultiRiCoHelpList.vue?vue&type=template&id=da2d18bc&"
import script from "./MultiRiCoHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiRiCoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports